import { __assign, __rest } from "tslib";
import React, { useContext, forwardRef } from 'react';
import { HeadingLevelContext } from '../context';
var HeadingLevelBoundary = forwardRef(function (_a, ref) {
    var tag = _a.tag, children = _a.children, rest = __rest(_a, ["tag", "children"]);
    var headingLevel = useContext(HeadingLevelContext);
    var Tag = tag;
    return Tag ? (React.createElement(HeadingLevelContext.Provider, { value: headingLevel + 1 },
        React.createElement(Tag, __assign({}, rest, { ref: ref }), children))) : (React.createElement(HeadingLevelContext.Provider, { value: headingLevel + 1 }, children));
});
HeadingLevelBoundary.displayName = 'HeadingLevelBoundary';
export default HeadingLevelBoundary;
//# sourceMappingURL=HeadingLevelBoundary.js.map